/**
 * LogosSVGs.tsx
 *
 * Reusable SVG logo components.
 * These components keep the JSX clean and make SVGs easier to maintain.
 */

/**
 * QStarLogo - Shows the Q-Star logo in yellow
 * Used for branding throughout the application
 */
export const QStarLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="52"
		height="46"
		viewBox="0 0 52 46"
		className="q-logo"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M22.322 28.916L19.8766 31.7136L36.1736 46.0001H41.8055L22.322 28.916Z"
			fill="#FFD214"
		/>
		<path
			d="M23.8426 27.2808L22.8994 28.2898L43.0643 45.965H45.0411L23.8426 27.2808Z"
			fill="#FFD214"
		/>
		<path
			d="M46.7042 12.7889C45.8099 10.267 44.3292 7.8951 42.4198 5.99177C41.4995 5.06843 40.4613 4.25074 39.3435 3.53412C35.8952 1.31689 31.6643 0.094958 27.5009 0.00614604C22.1645 -0.114822 16.9185 1.55729 12.5468 4.36865C9.88704 6.07139 7.51974 8.2381 5.60262 10.6774C3.66101 13.1304 2.12518 15.9295 1.15896 18.8756C0.177439 21.9105 -0.225277 25.1675 0.123846 28.3555C0.526562 31.8835 1.87712 35.3763 4.07751 38.2091C6.17225 40.8841 9.07701 43.008 12.285 44.2927C12.3248 44.3095 12.3661 44.3325 12.4029 44.3478C15.3628 45.5008 18.6136 45.9495 21.7986 45.8117C24.4369 45.6907 27.063 45.1441 29.5267 44.2605C30.3368 43.9696 31.1391 43.6297 31.9262 43.3066L28.0843 39.9149L25.8058 37.9013C25.1948 38.0207 24.5395 38.1677 23.9163 38.2596C22.0466 38.5306 20.0652 38.4633 18.1986 38.036C17.6137 37.9044 17.0425 37.7283 16.4729 37.5277C14.5037 36.8218 12.6647 35.707 11.2514 34.2324C9.58538 32.4945 8.45226 30.2313 7.98064 27.8763C7.38499 24.9409 7.77086 21.8263 8.8856 19.041C10.1458 15.9081 12.3324 13.1289 15.1009 11.0816C18.2308 8.75106 22.1477 7.31629 26.0814 7.31629C28.9678 7.31629 31.9093 8.10182 34.2843 9.68512C34.419 9.7724 34.5461 9.8704 34.6809 9.9684C36.7297 11.4323 38.3651 13.55 39.2532 15.8713C40.1949 18.378 40.3204 21.1755 39.7937 23.7848C39.3787 25.8979 38.5029 27.9283 37.3299 29.7183C36.9196 30.3262 36.4418 30.9357 35.9962 31.5298L41.3617 36.1817C41.524 35.9796 41.6848 35.7775 41.8486 35.5738C42.3279 34.9827 42.798 34.381 43.2436 33.7731C45.8681 30.0736 47.5617 25.5733 47.8419 21.0546C48.0119 18.2585 47.6474 15.4319 46.7027 12.7859"
			fill="#FFD214"
		/>
		<path
			d="M29.2279 26.8717L26.3798 24.4033L24.3356 26.7553L27.1562 29.2053L46.4621 45.9831H51.2732L29.2279 26.8717Z"
			fill="#FFD214"
		/>
	</svg>
);

/**
 * VisaLogo - Shows the Visa logo in white
 * Used for bank card issuer display
 */
export const VisaLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="732.26 728.88 1920.01 620.08"
		className="visa-logo-white"
		{...props}
	>
		<path
			d="M1461.26,739.84l-251.37,599.74h-164l-123.7-478.62c-7.51-29.48-14.04-40.28-36.88-52.7  c-37.29-20.23-98.87-39.21-153.05-50.99l3.68-17.43h263.99c33.65,0,63.9,22.4,71.54,61.15l65.33,347.04l161.46-408.2H1461.26z   M2103.84,1143.77c0.66-158.29-218.88-167.01-217.37-237.72c0.47-21.52,20.96-44.4,65.81-50.24c22.23-2.91,83.48-5.13,152.95,26.84  l27.25-127.18c-37.33-13.55-85.36-26.59-145.12-26.59c-153.35,0-261.27,81.52-262.18,198.25c-0.99,86.34,77.03,134.52,135.81,163.21  c60.47,29.38,80.76,48.26,80.53,74.54c-0.43,40.23-48.23,57.99-92.9,58.69c-77.98,1.2-123.23-21.1-159.3-37.87l-28.12,131.39  c36.25,16.63,103.16,31.14,172.53,31.87C1996.72,1348.96,2103.34,1268.45,2103.84,1143.77 M2508.78,1339.58h143.49l-125.25-599.74  h-132.44c-29.78,0-54.9,17.34-66.02,44l-232.81,555.74h162.91L2291,1250h199.05L2508.78,1339.58z M2335.67,1127.08l81.66-225.18  l47,225.18H2335.67z M1682.93,739.84l-128.29,599.74H1399.5l128.34-599.74H1682.93z"
			fill="#FFFFFF"
		/>
	</svg>
);

/**
 * MastercardLogo - Shows the Mastercard logo
 * Used for bank card issuer display
 */
export const MastercardLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		version="1.1"
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="17.87 17.99 116.53 72.03"
		className="mastercard-logo"
		{...props}
	>
		<g>
			<rect x="60.4" y="25.7" fill="#FF5F00" width="31.5" height="56.6"/>
			<path fill="#EB001B" d="M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3
				c13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z"/>
			<path fill="#F79E1B" d="M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6
				c15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z"/>
		</g>
	</svg>
);
